import { NextSeo } from "next-seo"
import { AllWorksViews, fields } from "."
import WorkIndex from "../../components/workIndex"
import { minifyRecords, base } from "../api/utils/airtable"

const Index = (props: any) => {
  const pageTitle = "Sculpture"

  return (
    <>
      <NextSeo title={pageTitle} />
      <WorkIndex initialWorks={props.works} />
    </>
  )
}
export default Index

export async function getStaticProps() {
  const table = base("All Works")
  try {
    const works = await table.select({ view: AllWorksViews.Sculpture, fields: fields }).all()

    return {
      props: {
        works: minifyRecords(works),
      },
    }
  } catch (err) {
    console.error(err)
  }
}
